(function () {
    'use strict';

    angular
        .module('cacmEventModule', [
            'services.modal',
            'gov.filters',
            'gov.services'
        ]);
})();
